import React, {FC, memo} from "react";
import {ApolloError} from "@apollo/client";
import LayoutStep from "../../views/LayoutStep/LayoutStep";
import LoadingContent from "../../views/LoadingContent/LoadingContent";
import {Maybe} from "../../generated/graphql";

type StepLoadingContentProps = {
    title?: string;
    subtitle?: Maybe<string> | React.ReactNode;
    loadingText?: string;
    button?: React.ReactNode;
    error?: ApolloError | Error | undefined;
    style?: React.CSSProperties;
};

const StepLoadingContent: FC<StepLoadingContentProps> = ({title, subtitle, loadingText = "Inhalte werden geladen...", button, error, style}) => {
    return (
        <LayoutStep columns={16} title={title} subtitle={subtitle} error={error} style={{minHeight: "300px", ...style}}>
            {error ? (
                <div style={{textAlign: "center", gridColumn: "span 16"}}>
                    <div>{"Leider ist ein Fehler aufgetreten:"}</div>
                    <div>{error.message}</div>
                </div>
            ) : (
                <LoadingContent content={loadingText} style={{gridColumn: "span 16"}} />
            )}
        </LayoutStep>
    );
};

export default memo(StepLoadingContent);
